import { GridLayout, GridItem } from '@nilohealth/core-ui'

import { Layout } from '@utils/layout'

import HomeSkeleton from '@dashboard/home/home.skeleton'
import NavbarSkeleton from '@navbar/navbar.skeleton'

const AppSkeleton = () => {
  return (
    <>
      <NavbarSkeleton />
      <Layout withoutNavbar={false}>
        <GridLayout>
          <GridItem column="span 12" css={{ flexDirection: 'column', width: '100%' }}>
            <HomeSkeleton />
          </GridItem>
        </GridLayout>
      </Layout>
    </>
  )
}

export default AppSkeleton
